class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    setTimeout(() => {
      this.classList.add('animate', 'active');
      window.amRefreshCartDrawerConversion?.();
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
      window.amRefreshCartDrawerConversion?.();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

(function () {
  const threshold = 5000;
  const upsells = [
    {
      title: 'Reise-Parf\u00fcmzerst\u00e4uber Set',
      price: '4,65 EUR',
      variantId: '57557123006795',
      url: '/products/reise-parfumzerstauber-set-2-stuck-5-ml-aluminium',
    },
    {
      title: 'Make-up Schw\u00e4mmchen Set',
      price: '6,75 EUR',
      variantId: '57558248161611',
      url: '/products/make-up-schwammchen-set-15-teilig-pink-fuchsia-creme',
    },
    {
      title: 'Reiseflaschen-Set 9-in-1',
      price: '5,70 EUR',
      variantId: '57557131297099',
      url: '/products/reiseflaschen-set-9-in-1-kosmetik-behalter-fur-unterwegs',
    },
  ];
  let refreshTimer;
  let rendering = false;

  function formatMoney(cents) {
    return (Math.max(cents, 0) / 100).toLocaleString('de-DE', {
      style: 'currency',
      currency: 'EUR',
    });
  }

  function updateCheckoutCopy() {
    const checkoutButton = document.querySelector('#CartDrawer-Checkout');
    if (checkoutButton) checkoutButton.textContent = 'Sicher auschecken';
  }

  function getMessage(cart) {
    const remaining = threshold - cart.total_price;

    if (!cart.item_count) {
      return {
        title: 'Dein Warenkorb wartet auf den ersten Lieblingsartikel.',
        text: 'Starte mit einem kleinen Auff\u00fcller oder entdecke passende Bestseller.',
      };
    }

    if (remaining > 0) {
      return {
        title: `Noch ${formatMoney(remaining)} bis kostenloser Versand.`,
        text: 'Erg\u00e4nze einen passenden Auff\u00fcller und nutze den Versandvorteil ab 50 EUR.',
      };
    }

    return {
      title: 'Kostenloser Versand ist erreicht.',
      text: 'Der Versandvorteil wird im Checkout automatisch ber\u00fccksichtigt.',
    };
  }

  function render(cart) {
    const drawer = document.querySelector('#CartDrawer');
    if (!drawer || !cart) return;

    updateCheckoutCopy();

    const footer = drawer.querySelector('.drawer__footer');
    const target = footer || drawer.querySelector('.drawer__inner-empty') || drawer.querySelector('.drawer__inner');
    if (!target) return;

    const progress = Math.min(100, Math.max(0, Math.round((cart.total_price / threshold) * 100)));
    const signature = `${cart.item_count}:${cart.total_price}:${progress}:${footer ? 'full' : 'empty'}`;
    const existing = drawer.querySelector('.am-drawer-conv');

    if (existing?.dataset.signature === signature) return;
    existing?.remove();

    const message = getMessage(cart);
    const block = document.createElement('div');
    block.className = 'am-drawer-conv';
    block.dataset.signature = signature;
    block.innerHTML = `
      <style>
        .am-drawer-conv{display:grid;gap:12px;margin:0 0 16px;padding:14px;border:1px solid rgba(0,0,0,.12);border-radius:10px;background:#fbf8f3;color:rgb(var(--color-foreground))}
        .am-drawer-conv strong{font-size:15px;line-height:1.3}
        .am-drawer-conv p{margin:0;font-size:12px;line-height:1.4;color:rgba(var(--color-foreground),.68)}
        .am-drawer-trust{display:flex;flex-wrap:wrap;gap:6px;font-size:11px;color:rgba(var(--color-foreground),.72)}
        .am-drawer-trust span{border:1px solid rgba(0,0,0,.1);border-radius:999px;background:#fff;padding:4px 7px}
        .am-drawer-bar{overflow:hidden;height:7px;border-radius:999px;background:rgba(0,0,0,.1)}
        .am-drawer-fill{display:block;height:100%;border-radius:inherit;background:linear-gradient(135deg,#7a1f3d,#e85a7b)}
        .am-drawer-list{display:grid;gap:8px}
        .am-drawer-item{display:grid;grid-template-columns:1fr auto;gap:8px;align-items:center;padding:9px;border:1px solid rgba(0,0,0,.1);border-radius:8px;background:#fff}
        .am-drawer-item a{color:inherit;text-decoration:none;font-weight:700;font-size:13px;line-height:1.25}
        .am-drawer-item small{display:block;color:rgba(var(--color-foreground),.62);font-size:12px;margin-top:2px}
        .am-drawer-item button{min-height:34px;border:0;border-radius:6px;background:#17130f;color:#fff;padding:0 10px;font-weight:700;cursor:pointer}
        .am-drawer-item button[disabled]{opacity:.6;cursor:wait}
      </style>
      <strong>${message.title}</strong>
      <p>${message.text}</p>
      <div class="am-drawer-bar" aria-hidden="true"><span class="am-drawer-fill" style="width:${progress}%"></span></div>
      <div class="am-drawer-trust" aria-label="Shop Vorteile"><span>DHL 1-3 Werktage</span><span>30 Tage R\u00fcckgabe</span><span>Originalware</span><span>Sicher bezahlen</span></div>
      <div class="am-drawer-list">
        ${upsells
          .map(
            (item) => `
          <div class="am-drawer-item">
            <a href="${item.url}">${item.title}<small>${item.price} \u00b7 schneller Auff\u00fcller</small></a>
            <button type="button" data-am-drawer-add="${item.variantId}">Dazu</button>
          </div>
        `
          )
          .join('')}
      </div>
    `;

    if (footer) {
      footer.insertBefore(block, footer.firstElementChild);
    } else {
      target.insertBefore(block, target.firstElementChild);
    }
  }

  async function refresh() {
    if (rendering) return;
    rendering = true;

    try {
      const response = await fetch('/cart.js', { credentials: 'same-origin' });
      if (response.ok) render(await response.json());
    } catch (error) {
      rendering = false;
      return;
    }

    rendering = false;
  }

  function scheduleRefresh() {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refresh, 120);
  }

  async function addUpsell(button) {
    button.disabled = true;
    button.textContent = '...';

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: button.dataset.amDrawerAdd, quantity: 1 }),
      });

      if (!response.ok) throw new Error('Cart add failed');
      window.location.href = '/cart';
    } catch (error) {
      button.disabled = false;
      button.textContent = 'Dazu';
    }
  }

  document.addEventListener('click', (event) => {
    const addButton = event.target.closest('[data-am-drawer-add]');
    if (addButton) {
      addUpsell(addButton);
      return;
    }

    if (event.target.closest('#cart-icon-bubble')) {
      scheduleRefresh();
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    scheduleRefresh();

    const observer = new MutationObserver(scheduleRefresh);
    observer.observe(document.body, { childList: true, subtree: true });
  });

  document.addEventListener('cart:updated', scheduleRefresh);
  window.amRefreshCartDrawerConversion = scheduleRefresh;
})();
